import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private apiUrl = `${environment.baseHref}`;
  constructor(private http: HttpClient) {}

  sendContact(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/contact`, data);
  }

  sendMailPaymentContact(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/contact/paymentContact`, data);
  }
}
